import { render, staticRenderFns } from "./AssociatedPlansCard.vue?vue&type=template&id=bebd05c0&scoped=true&"
import script from "./AssociatedPlansCard.vue?vue&type=script&lang=js&"
export * from "./AssociatedPlansCard.vue?vue&type=script&lang=js&"
import style0 from "./AssociatedPlansCard.vue?vue&type=style&index=0&id=bebd05c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebd05c0",
  null
  
)

export default component.exports